import Parse from 'parse';

let config = null;
export default async function getConfig(options) {
  if (!config) {
    config = Parse.Config.get();
  }

  return await config;
}
